import _ from 'lodash'
import { List, Map } from 'immutable'
import { LAYOUT_MODE, getValueForMode } from '../constants/toUnits'
import { getListOfProperties, getPropInfo } from '../constants/FormFieldsProperties'

export const copyPropertiesToDevice = function (elem, toMode, fromMode, isForce, IsConfiguredDevice) {
  const parentModes = LAYOUT_MODE.slice(0, LAYOUT_MODE.indexOf(toMode))
  let revercedModes = [...parentModes].reverse()
  revercedModes = _.filter(revercedModes, (mode) => {
    if (mode == 'lg' || !IsConfiguredDevice) {
      return true
    } else {
      IsConfiguredDevice.get(mode)
    }
  })
  if (IsConfiguredDevice) {
    if (!IsConfiguredDevice.get(toMode)) {
      isForce = true
    }
  }

  if (fromMode) {
    revercedModes = [fromMode]
  }

  if (isForce || !elem.getIn(['props', toMode, 'position'])) {
    let newPos = getValueForMode(elem.getIn(['props'], Map()), toMode, [], ['position'], Map())
    elem = elem.setIn(['props', toMode, 'position'], newPos)
  }
  switch (elem.get('type')) {
    case 'FormField':
      let listOfProps = getListOfProperties(elem, fromMode, true)
      _.each(listOfProps, function (propName) {
        let val = elem.getIn(['props', toMode, propName])
        if (isForce) {
          val = undefined
        }
        if (val === undefined) {
          _.each(revercedModes, function (mode) {
            if (val === undefined && elem.getIn(['props', mode, propName]) !== undefined) {
              val = elem.getIn(['props', mode, propName])
            }
          })
        }
        if (val === undefined) {
          let propInfo = getPropInfo(propName, elem, null, List())
          if (propInfo.default !== undefined) {
            val = propInfo.default
          } else if (propInfo.type === 'checkbox') {
            val = false
          } else if (propInfo.type === 'numeric' || propInfo.type === 'text' || propInfo.type === 'list') {
            val = ''
          }
        }
        if (
          isForce ||
          elem.getIn(['props', toMode, propName]) === undefined ||
          elem.getIn(['props', toMode, propName]) === null
        ) {
          elem = elem.setIn(['props', toMode, propName], val)
        }
      })
      break
    case 'Widget':
      let componentType = elem.getIn(['props', 'data', 'Type'])
      switch (componentType) {
        case 'chart':
          {
            if (isForce || elem.getIn(['props', 'data', 'Props', toMode, 'showLegend']) === undefined) {
              let val
              _.each(revercedModes, function (mode) {
                if (val === undefined && elem.getIn(['props', 'data', 'Props', mode, 'showLegend']) !== undefined) {
                  val = elem.getIn(['props', 'data', 'Props', mode, 'showLegend'])
                }
              })
              if (
                elem.getIn(['props', 'data', 'Props', toMode, 'showLegend']) === undefined ||
                elem.getIn(['props', 'data', 'Props', toMode, 'showLegend']) === null
              ) {
                elem = elem.setIn(['props', 'data', 'Props', toMode, 'showLegend'], val)
              }
            }
          }
          break
        case 'form':
          {
            if (isForce || elem.getIn(['props', 'data', 'Props', toMode, 'TwoColForm']) === undefined) {
              let val
              _.each(revercedModes, function (mode) {
                if (val === undefined && elem.getIn(['props', 'data', 'Props', mode, 'TwoColForm']) !== undefined) {
                  val = elem.getIn(['props', 'data', 'Props', mode, 'TwoColForm'])
                }
              })
              if (
                elem.getIn(['props', 'data', 'Props', toMode, 'TwoColForm']) === undefined ||
                elem.getIn(['props', 'data', 'Props', toMode, 'TwoColForm']) === null
              ) {
                elem = elem.setIn(['props', 'data', 'Props', toMode, 'TwoColForm'], val)
              }
            }
          }
          break
      }
      break
    case 'Typography':
      if (isForce || elem.getIn(['props', toMode, 'text']) === undefined) {
        let val = ''
        _.each(revercedModes, function (mode) {
          if (!val && elem.getIn(['props', mode, 'text'])) {
            val = elem.getIn(['props', mode, 'text'])
          }
        })
        if (elem.getIn(['props', toMode, 'text']) === undefined || elem.getIn(['props', toMode, 'text']) === null) {
          elem = elem.setIn(['props', toMode, 'text'], val)
        }
      }
      break
    case 'Image':
      if (isForce || elem.getIn(['props', toMode, 'src']) === undefined) {
        let val = ''
        _.each(revercedModes, function (mode) {
          if (!val && elem.getIn(['props', mode, 'src'])) {
            val = elem.getIn(['props', mode, 'src'])
          }
        })
        if (elem.getIn(['props', toMode, 'src']) === undefined || elem.getIn(['props', toMode, 'src']) === null) {
          elem = elem.setIn(['props', toMode, 'src'], val)
        }
      }
      break
  }
  return elem
}
